/**
 * @see https://wiki.navercorp.com/pages/viewpage.action?pageId=1051823734#id-[공통]Toast,Tooltip-Toast
 */
const DEFAULT_DURATION = 1500;
const FIXED_DURATION = -1;
const TOAST_ANIMATIONS = {
  SLIDE: 'slide',
  FADE: 'fade'
};
/**
 * @see https://www.figma.com/file/Nb0Z13nGDXC61AmC92xX2h/디자인시스템-개발-연계-전용?node-id=5488-25757
 */
const TOAST_BOTTOM_PADDING_BASE = {
  BASIC: 'basic',
  BUTTON: 'button'
};

export { DEFAULT_DURATION, FIXED_DURATION, TOAST_ANIMATIONS, TOAST_BOTTOM_PADDING_BASE };
